import styled from 'styled-components';

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -40px;
  margin-bottom: 15px;
  padding: 0 46px;
`;

export const FilterInputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  span {
    margin-right: 10px;
  }

  input {
    width: 162px !important;
    cursor: pointer;
  }

  .icon {
    position: absolute;
    right: 0px;
    cursor: pointer;
    z-index: -1;
  }
`;
